export const NOT_AVAILABLE_MESSAGE =
    "Недоступно в вашей роли. Обратитесь к HR/руководителю.";

const HR_MAIN_ROLES = ["superadmin", "admin"];
const HR_SUB_ROLES = ["hr_department"];
const STAFF_ROLES = ["staff", "private_person"];

const normalize = (value = "") =>
    String(value)
        .toLowerCase()
        .replace(/ё/g, "е")
        .replace(/[!?.,;:()[\]{}"«»'`–—-]/g, " ")
        .replace(/\s+/g, " ")
        .trim();

const INTENTS = [
    {
        id: "buy-tests",
        matchAll: [
            ["куп", "тест"],
            ["как", "куп", "тест"],
            ["как", "заказ", "тест"],
            ["заказ", "тест"],
            ["оплат", "тест"],
            ["приобрест", "тест"],
            ["добав", "тест"],
            ["купить", "доступ"],
            ["купить", "продукт"],
            ["купить", "подписк"],
            ["продлить", "подписк"],
            ["оформ", "заказ"],
            ["заказ", "продукт"],
        ],
        roles: {
            hrMain: {
                text:
                    "Конечно, подскажу! Закупка тестов и доступов делается в каталоге решений. " +
                    "Выберите нужный продукт и оформите заказ — он попадёт в раздел «Заказы».",
                action: { label: "Открыть каталог", route: "/catalog" },
            },
            hrSub: {
                text:
                    "Закупкой тестов и продуктов занимается главный HR/руководитель. " +
                    "Подскажите ему, какие именно тесты вам нужны — он оформит заказ в каталоге.",
                action: null,
            },
            staff: {
                text: NOT_AVAILABLE_MESSAGE,
                action: null,
            },
        },
    },
    {
        id: "my-orders",
        matchAll: [
            ["мои", "заказ"],
            ["где", "заказ"],
            ["посмотр", "заказ"],
            ["статус", "заказ"],
            ["истори", "заказ"],
        ],
        roles: {
            hrMain: {
                text: "Все ваши заказы и их статусы — в разделе «Заказы».",
                action: { label: "Перейти к заказам", route: "/my-orders" },
            },
            hrSub: {
                text:
                    "Раздел «Заказы» доступен — там видны заказы по вашей компании. " +
                    "Создавать новые заказы может только главный HR/руководитель.",
                action: { label: "Перейти к заказам", route: "/my-orders" },
            },
            staff: { text: NOT_AVAILABLE_MESSAGE, action: null },
        },
    },
    {
        id: "create-group",
        matchAll: [
            ["создат", "групп"],
            ["как", "создат", "групп"],
            ["добав", "групп"],
            ["новая", "групп"],
            ["сформиров", "групп"],
        ],
        roles: {
            hrMain: {
                text:
                    "Группы создаются в разделе «Группы». Нажмите «Создать группу», " +
                    "выберите сотрудников — и группа появится в списке.",
                action: { label: "К группам", route: "/groups" },
            },
            hrSub: {
                text:
                    "Группы создаются в разделе «Группы». Вы можете формировать группы " +
                    "из сотрудников, которые вам назначены.",
                action: { label: "К группам", route: "/groups" },
            },
            staff: { text: NOT_AVAILABLE_MESSAGE, action: null },
        },
    },
    {
        id: "run-testing",
        matchAll: [
            ["запуст", "тестиров"],
            ["назнач", "тестиров"],
            ["провест", "тестиров"],
            ["отправ", "тест"],
            ["назнач", "тест"],
            ["как", "запуст", "тестиров"],
            ["как", "провест", "тестиров"],
        ],
        roles: {
            hrMain: {
                text:
                    "Чтобы запустить тестирование по команде: создайте или выберите группу " +
                    "в разделе «Группы», затем назначьте нужный тест. После назначения " +
                    "сотрудники получат уведомление и ссылку на прохождение.",
                action: { label: "К группам", route: "/groups" },
            },
            hrSub: {
                text:
                    "Тестирование назначается на свою группу: откройте «Группы», выберите " +
                    "группу и назначьте нужный тест.",
                action: { label: "К группам", route: "/groups" },
            },
            staff: {
                text:
                    "Тестирование назначает HR/руководитель. Когда тест будет вам назначен, " +
                    "ссылка появится в личном кабинете в разделе «Моё развитие».",
                action: { label: "Открыть моё развитие", route: "/my-development" },
            },
        },
    },
    {
        id: "invite-staff",
        matchAll: [
            ["пригласи", "сотрудник"],
            ["как", "добав", "сотрудник"],
            ["как", "пригласи", "сотрудник"],
            ["добав", "сотрудник"],
            ["завест", "сотрудник"],
            ["создат", "сотрудник"],
            ["загруз", "сотрудник"],
            ["импорт", "сотрудник"],
        ],
        roles: {
            hrMain: {
                text:
                    "Сотрудников можно добавить в разделе «Сотрудники»: по одному через форму " +
                    "или массово через загрузку Excel. После добавления сотрудник получит " +
                    "приглашение на почту.",
                action: { label: "К сотрудникам", route: "/staff" },
            },
            hrSub: {
                text:
                    "Добавляйте сотрудников в разделе «Сотрудники» — они будут привязаны " +
                    "к вашей зоне ответственности.",
                action: { label: "К сотрудникам", route: "/staff" },
            },
            staff: { text: NOT_AVAILABLE_MESSAGE, action: null },
        },
    },
    {
        id: "hr-admins",
        matchAll: [
            ["hr", "администратор"],
            ["под", "hr"],
            ["создат", "hr"],
            ["добав", "hr"],
            ["назнач", "hr"],
        ],
        roles: {
            hrMain: {
                text:
                    "Под-HR (HR Администраторов) можно создать в разделе «HR Администраторы». " +
                    "Им назначаются группы — внутри своих групп они смогут управлять сотрудниками.",
                action: { label: "К HR Администраторам", route: "/hr/admins" },
            },
            hrSub: {
                text:
                    "Создание HR Администраторов доступно только главному HR/руководителю. " +
                    "Если нужен ещё один под-HR — напишите своему руководителю.",
                action: null,
            },
            staff: { text: NOT_AVAILABLE_MESSAGE, action: null },
        },
    },
    {
        id: "dashboard",
        matchAll: [
            ["дашборд"],
            ["мониторинг"],
            ["показател", "компани"],
            ["показател", "команд"],
            ["аналитик", "команд"],
        ],
        roles: {
            hrMain: {
                text:
                    "Дашборд по всей компании — в разделе «Аналитика → Мониторинг». " +
                    "Там видно ключевые показатели и «красные»/«зелёные» флаги.",
                action: { label: "Открыть мониторинг", route: "/analytics/dashboard" },
            },
            hrSub: {
                text:
                    "Дашборд доступен по вашим группам — откройте «Аналитика → Мониторинг».",
                action: { label: "Открыть мониторинг", route: "/analytics/dashboard" },
            },
            staff: { text: NOT_AVAILABLE_MESSAGE, action: null },
        },
    },
    {
        id: "special-reports",
        matchAll: [
            ["специальн", "отчет"],
            ["спец", "отчет"],
            ["специальн", "аналитик"],
        ],
        roles: {
            hrMain: {
                text:
                    "Специальные отчёты открываются в разделе «Аналитика → Отчёты». " +
                    "Там можно выбрать тип отчёта, сформировать его и скачать.",
                action: { label: "К специальным отчётам", route: "/analytics/reports" },
            },
            hrSub: {
                text:
                    "Специальные отчёты доступны в разделе «Аналитика → Отчёты».",
                action: { label: "К специальным отчётам", route: "/analytics/reports" },
            },
            staff: { text: NOT_AVAILABLE_MESSAGE, action: null },
        },
    },
    {
        id: "reports-testing",
        matchAll: [
            ["где", "отчет"],
            ["скача", "отчет"],
            ["скач", "отчет"],
            ["сформиров", "отчет"],
            ["отчет", "тестирован"],
            ["отчет", "прохожден"],
        ],
        roles: {
            hrMain: {
                text:
                    "Если речь про отчёты по тестированию, откройте раздел «Оценка». " +
                    "Там можно выбрать нужную выборку и скачать отчёт.",
                action: { label: "Открыть оценку", route: "/rating" },
            },
            hrSub: {
                text:
                    "Отчёты по тестированию находятся в разделе «Оценка». " +
                    "Там же доступно скачивание отчётов.",
                action: { label: "Открыть оценку", route: "/rating" },
            },
            staff: {
                text:
                    "Свои результаты тестирования вы найдёте в личном кабинете в разделе " +
                    "«Моё развитие».",
                action: { label: "Моё развитие", route: "/my-development" },
            },
        },
    },
    {
        id: "ei-results",
        matchAll: [
            ["мои", "результат"],
            ["где", "результат"],
            ["посмотр", "результат"],
            ["результат", "тест"],
            ["результат", "эи"],
            ["мой", "профиль", "эи"],
        ],
        roles: {
            hrMain: {
                text:
                    "Свои результаты ЭИ — в личном кабинете. Результаты по сотрудникам — " +
                    "в «Аналитика → Отчёты».",
                action: { label: "К моим результатам", route: "/personal" },
            },
            hrSub: {
                text:
                    "Свои результаты ЭИ — в личном кабинете. По вашим группам — " +
                    "в «Аналитика → Отчёты».",
                action: { label: "К моим результатам", route: "/personal" },
            },
            staff: {
                text:
                    "Ваши результаты тестирования находятся в разделе «Моё развитие». " +
                    "Там же видно прогресс по программам.",
                action: { label: "Моё развитие", route: "/my-development" },
            },
        },
    },
    {
        id: "training-simulator",
        matchAll: [
            ["тренажер"],
            ["где", "курс"],
            ["пройти", "курс"],
            ["программ", "развит"],
            ["развивающ", "программ"],
        ],
        roles: {
            hrMain: {
                text:
                    "Программы развития и тренажёры доступны в разделе «Моё развитие». " +
                    "Закупка курсов — в каталоге решений.",
                action: { label: "Моё развитие", route: "/my-development" },
            },
            hrSub: {
                text:
                    "Программы развития и тренажёры доступны в разделе «Моё развитие».",
                action: { label: "Моё развитие", route: "/my-development" },
            },
            staff: {
                text:
                    "Тренажёры и развивающие программы открываются в разделе «Моё развитие». " +
                    "Если в нём пусто — программу должен назначить ваш HR/руководитель.",
                action: { label: "Моё развитие", route: "/my-development" },
            },
        },
    },
    {
        id: "company-edit",
        matchAll: [
            ["данные", "компани"],
            ["реквизит"],
            ["настройк", "компани"],
            ["изменит", "компани"],
        ],
        roles: {
            hrMain: {
                text:
                    "Данные компании и реквизиты редактируются в разделе «Моя компания».",
                action: { label: "К моей компании", route: "/" },
            },
            hrSub: {
                text:
                    "Редактирование данных компании доступно только главному HR/руководителю.",
                action: null,
            },
            staff: { text: NOT_AVAILABLE_MESSAGE, action: null },
        },
    },
    {
        id: "notifications",
        matchAll: [
            ["настрой", "уведомлен"],
            ["напоминан"],
            ["где", "уведомлен"],
        ],
        roles: {
            hrMain: {
                text:
                    "Настройка напоминаний по тестам — в «Уведомления → По тестам», " +
                    "общие настройки — в «Уведомления → Параметры».",
                action: { label: "К уведомлениям", route: "/notifications/options" },
            },
            hrSub: {
                text:
                    "Настройка напоминаний по тестам — в «Уведомления → По тестам».",
                action: { label: "К уведомлениям", route: "/notifications/tests" },
            },
            staff: { text: NOT_AVAILABLE_MESSAGE, action: null },
        },
    },
    {
        id: "profile",
        matchAll: [
            ["мой", "профил"],
            ["изменит", "пароль"],
            ["смен", "пароль"],
            ["личн", "данные"],
            ["настройк", "профил"],
        ],
        roles: {
            hrMain: {
                text: "Профиль и смена пароля — в разделе «Профиль».",
                action: { label: "К профилю", route: "/profile" },
            },
            hrSub: {
                text: "Профиль и смена пароля — в разделе «Профиль».",
                action: { label: "К профилю", route: "/profile" },
            },
            staff: {
                text: "Профиль и смена пароля — в разделе «Профиль».",
                action: { label: "К профилю", route: "/profile" },
            },
        },
    },
    {
        id: "support",
        matchAll: [
            ["поддержк"],
            ["обратн", "связ"],
            ["связ", "поддержк"],
            ["написать", "поддержк"],
            ["сообщить", "ошибк"],
        ],
        roles: {
            hrMain: {
                text:
                    "Форма обратной связи доступна в боковой панели слева — блок «Мы на связи!». " +
                    "Там можно задать вопрос, сообщить об ошибке или поделиться идеей.",
                action: null,
            },
            hrSub: {
                text:
                    "Форма обратной связи — в боковой панели слева, блок «Мы на связи!».",
                action: null,
            },
            staff: {
                text:
                    "Форма обратной связи — в боковой панели слева, блок «Мы на связи!».",
                action: null,
            },
        },
    },
    {
        id: "faq",
        matchAll: [
            ["faq"],
            ["помощ", "кабинет"],
            ["инструкц"],
            ["база", "знани", "кабинет"],
        ],
        roles: {
            hrMain: {
                text: "Полная справка по личному кабинету — в разделе «Помощь с ЛК».",
                action: { label: "Открыть помощь", route: "/faq" },
            },
            hrSub: {
                text: "Полная справка по личному кабинету — в разделе «Помощь с ЛК».",
                action: { label: "Открыть помощь", route: "/faq" },
            },
            staff: {
                text: "Полная справка по личному кабинету — в разделе «Помощь с ЛК».",
                action: { label: "Открыть помощь", route: "/faq" },
            },
        },
    },
    {
        id: "diary",
        matchAll: [
            ["дневник", "эмоц"],
            ["журнал", "эмоц"],
        ],
        roles: {
            hrMain: {
                text: "Дневник эмоций — в разделе «Дневник эмоций» личного кабинета.",
                action: { label: "К дневнику", route: "/diary" },
            },
            hrSub: {
                text: "Дневник эмоций — в разделе «Дневник эмоций» личного кабинета.",
                action: { label: "К дневнику", route: "/diary" },
            },
            staff: {
                text: "Дневник эмоций — в разделе «Дневник эмоций» личного кабинета.",
                action: { label: "К дневнику", route: "/diary" },
            },
        },
    },
    {
        id: "mood-tracker",
        matchAll: [
            ["навигатор", "эмоц"],
            ["трекер", "настроен"],
            ["трекер", "эмоц"],
            ["батарейк"],
        ],
        roles: {
            hrMain: {
                text:
                    "Навигатор эмоций — раздел, где можно отмечать настроение и получать " +
                    "рекомендации. Откройте «Навигатор эмоций».",
                action: { label: "Открыть навигатор", route: "/mood/tracker" },
            },
            hrSub: {
                text:
                    "Навигатор эмоций — в личном кабинете. Помогает отслеживать настроение " +
                    "и получать рекомендации.",
                action: { label: "Открыть навигатор", route: "/mood/tracker" },
            },
            staff: {
                text:
                    "Навигатор эмоций поможет отследить настроение и получить рекомендации. " +
                    "Откройте раздел в личном кабинете.",
                action: { label: "Открыть навигатор", route: "/mood/tracker" },
            },
        },
    },
    {
        id: "emotion-library",
        matchAll: [
            ["библиотек", "эмоц"],
            ["список", "эмоц"],
            ["27", "эмоц"],
        ],
        roles: {
            hrMain: {
                text: "Библиотека из 27 эмоций — раздел «Библиотека эмоций».",
                action: { label: "Открыть библиотеку", route: "/library/list" },
            },
            hrSub: {
                text: "Библиотека из 27 эмоций — раздел «Библиотека эмоций».",
                action: { label: "Открыть библиотеку", route: "/library/list" },
            },
            staff: {
                text: "Библиотека из 27 эмоций — раздел «Библиотека эмоций».",
                action: { label: "Открыть библиотеку", route: "/library/list" },
            },
        },
    },
    {
        id: "subscription",
        matchAll: [
            ["подписк"],
            ["тариф"],
        ],
        roles: {
            hrMain: {
                text:
                    "Управление подпиской и её продление — в разделе «Подписка».",
                action: { label: "Подписка", route: "/subscription" },
            },
            hrSub: {
                text:
                    "Управление подпиской доступно главному HR/руководителю. " +
                    "Если нужно продлить или изменить тариф — напишите ему.",
                action: null,
            },
            staff: { text: NOT_AVAILABLE_MESSAGE, action: null },
        },
    },
    {
        id: "catalog",
        matchAll: [
            ["каталог"],
            ["реш", "продукт"],
            ["выбрать", "продукт"],
            ["выбрать", "тест"],
        ],
        roles: {
            hrMain: {
                text:
                    "Каталог решений — раздел, где собраны все доступные тесты, курсы и продукты " +
                    "для заказа.",
                action: { label: "Открыть каталог", route: "/catalog" },
            },
            hrSub: {
                text:
                    "Каталог продуктов доступен для просмотра, оформление заказа — на главном HR.",
                action: { label: "Открыть каталог", route: "/catalog" },
            },
            staff: { text: NOT_AVAILABLE_MESSAGE, action: null },
        },
    },
];

const matchesIntent = (normalizedText, intent) =>
    intent.matchAll.some((terms) =>
        terms.every((term) => normalizedText.includes(term))
    );

const roleAnswerKey = (role) => {
    if (HR_MAIN_ROLES.includes(role)) return "hrMain";
    if (HR_SUB_ROLES.includes(role)) return "hrSub";
    if (STAFF_ROLES.includes(role)) return "staff";
    return null;
};

export const findLine1Reply = (question, role) => {
    const normalized = normalize(question);
    if (!normalized) return null;

    const intent = INTENTS.find((item) => matchesIntent(normalized, item));
    if (!intent) return null;

    const key = roleAnswerKey(role);
    if (!key) return null;

    const answer = intent.roles[key];
    if (!answer) return null;

    return {
        intentId: intent.id,
        text: answer.text,
        action: answer.action ?? null,
    };
};
